(function () {

  /* ---- PRICE FORMAT: text nodes only ---- */
  function fixTextNodes(el) {
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3 && n.nodeValue.indexOf('Rs.') > -1) {
        n.nodeValue = n.nodeValue.replace(/Rs\.\s*/g, '\u20B9').replace(/\.00(?!\d)/g, '');
      }
    });
  }
  function formatPrices() {
    document.querySelectorAll('.price-item, .price__regular, .price__sale, .totals__subtotal-value, .cart-item__price-wrapper .price, .cart-item__price-wrapper .money').forEach(fixTextNodes);
  }
  formatPrices();

  /* ---- TRUST STRIP in fixed header (non-home) ---- */
  if (!document.body.classList.contains('template-index')) {
    var hg = document.querySelector('.shopify-section-group-header-group');
    if (hg && !document.querySelector('.blyth-strip')) {
      var strip = document.createElement('div');
      strip.className = 'blyth-strip';
      strip.textContent = 'FREE SHIPPING ACROSS INDIA \u00B7 7-DAY SIZE EXCHANGE';
      hg.appendChild(strip);
    }
  }

  /* ---- CART trust ---- */
  function addCartTrust() {
    var btn = document.getElementById('checkout');
    if (btn && !document.querySelector('.blyth-cart-trust')) {
      var d = document.createElement('div');
      d.className = 'blyth-cart-trust';
      d.innerHTML = 'Free Shipping Across India &nbsp;\u00B7&nbsp; 7-Day Easy Size Exchange & Returns';
      btn.parentElement.appendChild(d);
    }
  }
  addCartTrust();
  if (document.body.classList.contains('template-cart')) {
    var mainEl = document.getElementById('MainContent');
    if (mainEl) {
      new MutationObserver(function () { formatPrices(); addCartTrust(); }).observe(mainEl, { childList: true, subtree: true });
    }
  }

  /* ---- PDP trust row ---- */
  if (document.body.classList.contains('template-product')) {
    var buyBtns = document.querySelector('.product-form__buttons') || document.querySelector('.product-form__submit');
    if (buyBtns && !document.querySelector('.blyth-trust-row')) {
      var row = document.createElement('div');
      row.className = 'blyth-trust-row';
      row.innerHTML = '<span>Free Shipping Across India</span><span>7-Day Size Exchange</span><span>100% Cotton \u00B7 240 GSM</span>';
      buyBtns.insertAdjacentElement('afterend', row);
    }
  }

  /* ---- HOMEPAGE ---- */
  if (document.body.classList.contains('template-index')) {
    function checkScroll() {
      if (window.scrollY > 60) { document.body.classList.add('blyth-scrolled'); }
      else { document.body.classList.remove('blyth-scrolled'); }
    }
    window.addEventListener('scroll', checkScroll, { passive: true });
    checkScroll();

    // Spinning logo mark centered on the hero image (Bluorng-style)
    var heroBanner = document.querySelector('[id*="image_banner_DyYAit"] .banner');
    var cssLink = document.querySelector('link[href*="blyth-desc-patch"]');
    if (heroBanner && cssLink && !document.querySelector('.blyth-hero-logo')) {
      var assetBase = cssLink.href.split('?')[0].replace(/blyth-desc-patch\.css$/, '');
      var heroLogo = document.createElement('img');
      heroLogo.src = assetBase + 'blyth-logo-white.png?v=2';
      heroLogo.alt = '';
      heroLogo.className = 'blyth-hero-logo';
      heroBanner.appendChild(heroLogo);
    }

    var heroHeading = document.querySelector('.banner__content .banner__heading');
    if (heroHeading) {
      var chips = document.createElement('div');
      chips.className = 'blyth-hero-chips';
      chips.innerHTML = '<span>240 GSM</span><span>French Terry Cotton</span><span>Screen + Puff Prints</span>';
      heroHeading.insertAdjacentElement('afterend', chips);
    }

    // Shoppable hotspots — both lifestyle banners
    [
      { banner: 'image_banner_MTzkJx', left: '34%', top: '48%', url: '/products/effort-luck-tee', label: 'Effort > Luck Tee' },
      { banner: 'image_banner_MTzkJx', left: '66%', top: '42%', url: '/products/crown-ur-soul-tee', label: 'Crown Ur Soul Tee' },
      { banner: 'image_banner_piano', left: '41%', top: '46%', url: '/products/full-throttle-living-tee', label: 'Full Throttle Living Tee' },
      { banner: 'image_banner_piano', left: '63%', top: '42%', url: '/products/wings-of-resilience-tee', label: 'Wings of Resilience Tee' }
    ].forEach(function (s) {
      var b = document.querySelector('[id*="' + s.banner + '"] .banner');
      if (!b) return;
      var a = document.createElement('a');
      a.href = s.url;
      a.className = 'blyth-spot';
      a.style.left = s.left;
      a.style.top = s.top;
      a.innerHTML = '<span class="blyth-spot-dot">+</span><span class="blyth-spot-label">' + s.label + '</span>';
      b.appendChild(a);
    });
  }

  /* ---- SIZE GUIDE ---- */
  var sgModal = document.createElement('div');
  sgModal.id = 'blyth-sg-modal';
  sgModal.innerHTML = ['<div class="blyth-sg-overlay"></div>','<div class="blyth-sg-dialog">','<button class="blyth-sg-close">&times;</button>','<h3 class="blyth-sg-title">SIZE GUIDE</h3>','<div class="blyth-sg-table-wrap"><table class="blyth-sg-table"><thead><tr><th>SIZE</th><th>CHEST (in)</th><th>LENGTH (in)</th><th>SHOULDER (in)</th></tr></thead><tbody><tr><td>XS</td><td>38</td><td>27</td><td>17</td></tr><tr><td>S</td><td>40</td><td>28</td><td>18</td></tr><tr><td>M</td><td>42</td><td>29</td><td>19</td></tr><tr><td>L</td><td>44</td><td>30</td><td>20</td></tr><tr><td>XL</td><td>46</td><td>31</td><td>21</td></tr><tr><td>XXL</td><td>48</td><td>32</td><td>22</td></tr></tbody></table></div>','<p class="blyth-sg-note">All measurements in inches. Model wears size M.</p>','</div>'].join('');
  document.body.appendChild(sgModal);
  sgModal.querySelector('.blyth-sg-overlay').addEventListener('click', function(){ sgModal.classList.remove('is-open'); });
  sgModal.querySelector('.blyth-sg-close').addEventListener('click', function(){ sgModal.classList.remove('is-open'); });

  /* ---- QUICK VIEW MODAL ---- */
  var modal = document.createElement('div');
  modal.id = 'blyth-qv-modal';
  modal.innerHTML = ['<div class="blyth-qv-overlay"></div>','<div class="blyth-qv-dialog">','<button class="blyth-qv-close">&times;</button>','<div class="blyth-qv-images"><div class="blyth-qv-main-img-wrap"><button class="blyth-qv-arrow blyth-qv-prev">&#8592;</button><img class="blyth-qv-main-img" src="" alt=""><button class="blyth-qv-arrow blyth-qv-next">&#8594;</button></div></div>','<div class="blyth-qv-info">','<h2 class="blyth-qv-title"></h2>','<p class="blyth-qv-price"></p>','<div class="blyth-qv-size-row"><span class="blyth-qv-size-label">SIZE</span><button class="blyth-qv-sg-btn" type="button">Size Guide</button></div>','<div class="blyth-qv-sizes"></div>','<button class="blyth-qv-atc" type="button" disabled>Select a Size</button>','<button class="blyth-qv-buynow" type="button" disabled>Buy Now</button>','<a class="blyth-qv-view-product" href="#">VIEW PRODUCT DETAILS</a>','<div class="blyth-qv-divider"></div>','<p class="blyth-qv-det-label" style="display:none">DETAILS</p>','<div class="blyth-qv-desc"></div>','</div>','</div>'].join('');
  document.body.appendChild(modal);

  var qvOverlay=modal.querySelector('.blyth-qv-overlay'),qvClose=modal.querySelector('.blyth-qv-close'),qvImg=modal.querySelector('.blyth-qv-main-img'),qvPrev=modal.querySelector('.blyth-qv-prev'),qvNext=modal.querySelector('.blyth-qv-next'),qvTitle=modal.querySelector('.blyth-qv-title'),qvPrice=modal.querySelector('.blyth-qv-price'),qvSizes=modal.querySelector('.blyth-qv-sizes'),qvAtc=modal.querySelector('.blyth-qv-atc'),qvBuy=modal.querySelector('.blyth-qv-buynow'),qvView=modal.querySelector('.blyth-qv-view-product'),qvSgBtn=modal.querySelector('.blyth-qv-sg-btn'),qvDetLabel=modal.querySelector('.blyth-qv-det-label'),qvDesc=modal.querySelector('.blyth-qv-desc');

  qvSgBtn.addEventListener('click',function(){ sgModal.classList.add('is-open'); });
  var imgs=[],imgIdx=0,selVariant=null;
  function goImg(n){ imgIdx=(n+imgs.length)%imgs.length; qvImg.src=imgs[imgIdx]; }
  qvPrev.addEventListener('click',function(){ goImg(imgIdx-1); });
  qvNext.addEventListener('click',function(){ goImg(imgIdx+1); });

  function resetButtons(){
    selVariant=null;
    qvAtc.textContent='Select a Size'; qvAtc.disabled=true; qvAtc.classList.remove('is-ready','is-added');
    qvBuy.disabled=true; qvBuy.classList.remove('is-ready'); qvBuy.textContent='Buy Now';
  }
  function openModal(){ modal.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function closeModal(){ modal.classList.remove('is-open'); document.body.style.overflow=''; resetButtons(); }
  qvClose.addEventListener('click',closeModal);
  qvOverlay.addEventListener('click',closeModal);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeModal(); sgModal.classList.remove('is-open'); } });

  function rupees(c){ return '\u20B9' + Math.round(c/100).toLocaleString('en-IN'); }

  function extractDetails(raw){
    if(!raw) return '';
    var i = raw.toUpperCase().lastIndexOf('DETAILS');
    if(i === -1) return raw;
    var rest = raw.slice(i);
    var closers = ['</h4>','</h3>','</h2>','</h5>','</h6>','</p>','</strong>'];
    var best = -1;
    for(var c=0;c<closers.length;c++){
      var pos = rest.indexOf(closers[c]);
      if(pos > -1 && (best === -1 || pos < best)){ best = pos; }
    }
    if(best === -1) return raw;
    var tagEnd = rest.indexOf('>', best);
    if(tagEnd === -1) return raw;
    var out = rest.slice(tagEnd+1).trim();
    return out || raw;
  }

  function loadProduct(handle,url,descHtml){
    imgs=[]; imgIdx=0; qvTitle.textContent='Loading...'; qvPrice.textContent=''; qvDesc.innerHTML=''; qvSizes.innerHTML=''; qvImg.src=''; qvView.href=url; qvDetLabel.style.display='none';
    resetButtons();
    openModal();

    if(descHtml && descHtml.trim()){
      var det = extractDetails(descHtml);
      if(det.trim()){ qvDesc.innerHTML=det; qvDetLabel.style.display=''; }
    }

    fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p){
      qvTitle.textContent=p.title; qvPrice.textContent=rupees(p.price_min); qvView.href='/products/'+p.handle;
      imgs=p.images||[]; qvPrev.style.display=imgs.length>1?'':'none'; qvNext.style.display=imgs.length>1?'':'none';
      if(imgs.length){ qvImg.src=imgs[0]; qvImg.alt=p.title; }

      if(!qvDesc.innerHTML && p.body_html){
        var det2 = extractDetails(p.body_html);
        if(det2.trim()){ qvDesc.innerHTML=det2; qvDetLabel.style.display=''; }
      }

      p.variants.forEach(function(v){
        var btn=document.createElement('button'); btn.type='button'; btn.textContent=v.title;
        btn.className='blyth-qv-size-btn'+(v.available?'':' is-sold-out'); btn.disabled=!v.available;
        btn.addEventListener('click',function(){
          qvSizes.querySelectorAll('.blyth-qv-size-btn').forEach(function(b){ b.classList.remove('is-selected'); });
          btn.classList.add('is-selected'); selVariant=v.id;
          qvAtc.textContent='Add to Cart'; qvAtc.disabled=false; qvAtc.classList.add('is-ready');
          qvBuy.disabled=false; qvBuy.classList.add('is-ready');
        });
        qvSizes.appendChild(btn);
      });
    }).catch(function(){ qvTitle.textContent='Could not load product.'; });
  }

  qvAtc.addEventListener('click',function(){
    if(!selVariant||qvAtc.disabled) return;
    qvAtc.textContent='Adding...'; qvAtc.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:selVariant,quantity:1})})
      .then(function(r){ return r.json(); })
      .then(function(){ qvAtc.textContent='Added \u2713'; qvAtc.classList.add('is-added'); updateCart(); setTimeout(function(){ qvAtc.textContent='Add to Cart'; qvAtc.classList.remove('is-added'); qvAtc.disabled=false; },2000); })
      .catch(function(){ qvAtc.textContent='Add to Cart'; qvAtc.disabled=false; });
  });

  qvBuy.addEventListener('click',function(){
    if(!selVariant||qvBuy.disabled) return;
    qvBuy.textContent='Processing...'; qvBuy.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:selVariant,quantity:1})})
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){ qvBuy.textContent='Buy Now'; qvBuy.disabled=false; });
  });

  /* ---- CART POPUP ---- */
  var popup=document.createElement('div'); popup.className='blyth-cart-popup';
  popup.innerHTML='<p class="blyth-cart-popup__title">Added to Cart</p><p class="blyth-cart-popup__item" id="bpopitem"></p><div class="blyth-cart-popup__actions"><a href="/cart" class="blyth-cart-popup__view">View Cart</a><button class="blyth-cart-popup__close" id="bpopclose">Continue Shopping</button></div>';
  document.body.appendChild(popup);
  var popItem=popup.querySelector('#bpopitem'),popTimer;
  popup.querySelector('#bpopclose').addEventListener('click',function(){ popup.classList.remove('is-visible'); clearTimeout(popTimer); });

  function showPopup(title,size){ popItem.textContent=title+(size?' \u2014 '+size:''); popup.classList.add('is-visible'); clearTimeout(popTimer); popTimer=setTimeout(function(){ popup.classList.remove('is-visible'); },4000); }
  function updateCart(){ fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ var el=document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]'); if(el) el.textContent=c.item_count; var bub=document.querySelector('#cart-icon-bubble .cart-count-bubble'); if(bub&&c.item_count>0) bub.removeAttribute('hidden'); }); }

  /* ---- DELEGATION ---- */
  document.addEventListener('click',function(e){
    if(e.target.classList.contains('blyth-quick-view-label')){
      e.preventDefault(); e.stopPropagation();
      var h=e.target.dataset.productHandle,u=e.target.dataset.productUrl,d=e.target.dataset.productDesc||'';
      if(h) loadProduct(h,u,d);
      return;
    }
    if(e.target.classList.contains('blyth-atc-btn')){
      e.preventDefault(); e.stopPropagation();
      var card=e.target.closest('.card-wrapper'); if(!card) return;
      var sel=card.querySelector('.blyth-size-select'); if(!sel) return;
      var vid=parseInt(sel.value,10),sz=sel.options[sel.selectedIndex].text.replace(' \u2014 Sold out','').trim(),ttl=((card.querySelector('.card__heading a')||{}).textContent||'').trim();
      if(!vid||isNaN(vid)) return;
      var btn=e.target; btn.textContent='Adding...'; btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
        .then(function(r){ if(!r.ok) return r.json().then(function(d2){ throw new Error(d2.description); }); return r.json(); })
        .then(function(){ btn.textContent='Added \u2713'; btn.classList.add('is-added'); showPopup(ttl,sz); updateCart(); setTimeout(function(){ btn.textContent='Add to Cart'; btn.classList.remove('is-added'); btn.disabled=false; },2000); })
        .catch(function(){ btn.textContent='Add to Cart'; btn.disabled=false; });
      return;
    }
    if(e.target.closest('.blyth-atc-row')) e.stopPropagation();
  },true);

})();
